import { call, put, takeLatest, takeEvery } from "redux-saga/effects";
import { DocUser } from "../../models";
import { notification, navigate, eventEmitter } from "../../services";
import {
    DOC_USER_FETCH_ALL,
    DOC_USER_FETCH,
    DOC_USER_SET,
    DOC_USER_DESTROY,
    DOC_USER_SAVE,
    DOC_USER_REMOVE,
    DOC_USER_CREATE,
} from "./actions";
import { FORM_CLEAR, FORM_END_PROCESSING } from "../../lib";
import { UD_EDITOR } from "../../settings";
import { AxiosResponse } from "axios";

function* fetchDocUsers(action: {
    type: typeof DOC_USER_FETCH_ALL;
    payload: { doc_id: number };
}) {
    const { doc_id } = action.payload;
    try {
        const { data }: AxiosResponse<Array<any>> = yield call(
            [DocUser, "list"],
            { doc_id }
        );
        for (let r of data) {
            yield put({
                type: DOC_USER_SET,
                payload: r,
            });
        }
    } catch (e) {}
}

function* onFetchDocUsers() {
    yield takeLatest(DOC_USER_FETCH_ALL, fetchDocUsers);
}

function* fetchDocUser(action: {
    type: typeof DOC_USER_FETCH;
    payload: {
        doc_id: number;
        user_id: number;
    };
}) {
    try {
        const { doc_id, user_id } = action.payload;
        const { data }: AxiosResponse<any> = yield call(
            [DocUser, "fetch"],
            user_id,
            { doc_id }
        );
        yield put({
            type: DOC_USER_SET,
            payload: data,
        });
    } catch (e) {}
}

function* onFetchDocUser() {
    yield takeEvery(DOC_USER_FETCH, fetchDocUser);
}

function* createDocUser(action: {
    type: typeof DOC_USER_CREATE;
    payload: {
        doc_id: number;
        data: any;
        redirect: string;
    };
}) {
    try {
        const { doc_id, data, redirect } = action.payload;
        const res: AxiosResponse<any> = yield call([DocUser, "create"], data, {
            doc_id,
        });
        yield put({
            type: DOC_USER_SET,
            payload: res.data,
        });

        if (redirect === UD_EDITOR) {
            navigate.to(`/app/e/${doc_id}/${res.data.id}`);
        }

        eventEmitter.emit(FORM_END_PROCESSING);
        eventEmitter.emit(FORM_CLEAR);
        notification.set("userDocForm.added", "s");
    } catch (e) {
        eventEmitter.emit(FORM_END_PROCESSING);
        notification.apiError(e);
    }
}

function* onCreateDocUser() {
    yield takeLatest(DOC_USER_CREATE, createDocUser);
}

function* saveDocUser(action: {
    type: typeof DOC_USER_SAVE;
    payload: {
        doc_id: number;
        user_id: number;
        data: any;
    };
}) {
    try {
        const { doc_id, user_id, data } = action.payload;
        const res: AxiosResponse<any> = yield call(
            [DocUser, "save"],
            data,
            user_id,
            { doc_id }
        );
        yield put({
            type: DOC_USER_SET,
            payload: res.data,
        });
        eventEmitter.emit(FORM_END_PROCESSING);
        notification.set("userDocForm.saved", "s");
    } catch (e) {
        eventEmitter.emit(FORM_END_PROCESSING);
        notification.set("userDocForm.failed", "f");
    }
}

function* onSaveDocUser() {
    yield takeLatest(DOC_USER_SAVE, saveDocUser);
}

function* destroyDocUser(action: {
    type: typeof DOC_USER_DESTROY;
    payload: {
        user_id: number;
        doc_id: number;
    };
}) {
    try {
        const { user_id, doc_id } = action.payload;
        yield call([DocUser, "destroy"], user_id, { doc_id });
        yield put({
            type: DOC_USER_REMOVE,
            payload: { doc_id, user_id },
        });
        eventEmitter.emit("doc_user.deleted");
    } catch (e) {}
}

function* onDestroyDocUser() {
    yield takeEvery(DOC_USER_DESTROY, destroyDocUser);
}

export {
    onFetchDocUser,
    onFetchDocUsers,
    onCreateDocUser,
    onSaveDocUser,
    onDestroyDocUser,
};
